import { render, staticRenderFns } from "./Chief.vue?vue&type=template&id=3c1d5fcf&scoped=true"
import script from "./Chief.vue?vue&type=script&lang=js"
export * from "./Chief.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1d5fcf",
  null
  
)

export default component.exports